export default "__VITE_ASSET__DsiCtMDa__"